import {
  ChangeDetectionStrategy, Component, EventEmitter, Input, Output,
} from '@angular/core';
import { MarkdownPipe } from '../../../../shared/pipes/markdown.pipe';
import {
  AiRoleChatMessage, AiRoleAction, DownloadItem,
  DOC_TYPE_LABELS, FOOTER_PATTERN, NEXT_ACTIONS, TOOL_DISPLAY,
} from '../../models/ai-role.model';

@Component({
  selector: 'app-ai-role-renderer',
  standalone: true,
  imports: [MarkdownPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ai-role-renderer.component.html',
  styleUrls: ['./ai-role-renderer.component.scss'],
})
export class AiRoleRendererComponent {
  @Input() msg!: AiRoleChatMessage;
  @Input() msgIdx = 0;
  @Input() isPast = false;
  @Input() isProcessing = false;

  @Output() action = new EventEmitter<AiRoleAction>();

  readonly nextActions = NEXT_ACTIONS;
  readonly docTypeLabels = DOC_TYPE_LABELS;

  get hasDownloads(): boolean {
    return (this.msg.downloads?.length ?? 0) > 0;
  }

  hasFooter(content: string): boolean {
    return FOOTER_PATTERN.test(content ?? '');
  }

  stripFooter(content: string): string {
    return (content ?? '').replace(FOOTER_PATTERN, '').trimEnd();
  }

  toolLabel(name: string): string {
    return TOOL_DISPLAY[name]?.label ?? name;
  }

  toolIcon(name: string): string {
    return TOOL_DISPLAY[name]?.icon ?? 'pi-cog';
  }

  docLabel(item: DownloadItem): string {
    return this.docTypeLabels[item.docType] || item.filename;
  }

  onDownload(item: DownloadItem): void {
    window.open(item.url, '_blank', 'noopener');
  }

  onQuickAction(value: string): void {
    if (this.isPast || this.isProcessing) return;
    this.action.emit({ type: 'send-message', payload: value, msgIdx: this.msgIdx });
  }
}
